import AbstractWidget from "@/models/WebsiteWidget/AbstractWidget";
import WebsiteWidget from "@/models/WebsiteWidget/WebsiteWidget";

export default class CountryInformation extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/country-information';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetCountryInformations';

    static model_name = 'CountryInformation';

    static fields() {
		return {
			id: this.attr(null),
			country_id: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
            widget: this.hasOne(WebsiteWidget, 'widgetable_id'),
		}
	}

    /**
     *
     * @returns {*}
     * @constructor
     */
    Widget() {
        return WebsiteWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }

}
